import React from "react";
import { Link } from "react-router-dom";
import CourseCard from "../components/CourseCard";
import "./Services.css";
import {
  OnlineTrainingIcon,
  PhysicalTrainingIcon,
  HybridTrainingIcon,
} from "../components/ValueIcons";

const Services = () => {
  const allCourses = [
    {
      id: 1,
      title: "Care Giver",
      description:
        "Professional training for caregivers including elderly care, patient support, and healthcare assistance. Course includes manual book and practical training.",
      duration: "1 month theory + 2 months practical",
      discount: "30% OFF",
      color: "turquoise",
      details: [
        "Elderly care techniques",
        "Patient support and assistance",
        "Healthcare basics",
        "Communication skills",
        "Practical hands-on training",
      ],
    },
    {
      id: 2,
      title: "Child Minder",
      description:
        "Comprehensive child care training covering child development, safety, nutrition, and educational activities. Includes certification upon completion.",
      duration: "1 month theory + 2 months practical",
      discount: "30% OFF",
      color: "pink",
      details: [
        "Child development stages",
        "Safety and first aid",
        "Nutrition for children",
        "Educational activities",
        "Behavior management",
      ],
    },
    {
      id: 3,
      title: "Farming",
      description:
        "Modern agricultural training covering sustainable farming practices, crop management, livestock care, and agribusiness fundamentals.",
      duration: "2 weeks theory + 1 month practical",
      discount: "30% OFF",
      color: "green",
      details: [
        "Sustainable farming practices",
        "Crop selection and management",
        "Livestock care basics",
        "Irrigation techniques",
        "Agribusiness fundamentals",
      ],
    },
    {
      id: 4,
      title: "Warehouse Packer",
      description:
        "Training in warehouse operations including inventory management, packing techniques, logistics, and safety protocols for warehouse environments.",
      duration: "2 weeks theory + 1 month practical",
      discount: "30% OFF",
      color: "blue",
      details: [
        "Inventory management systems",
        "Packing and labeling techniques",
        "Logistics and supply chain basics",
        "Warehouse safety protocols",
        "Equipment operation training",
      ],
    },
    {
      id: 5,
      title: "Psycho Social Counselling",
      description:
        "Professional training in psychosocial counselling techniques, mental health support, communication skills, and ethical practice standards.",
      duration: "Comprehensive online training",
      discount: "30% OFF",
      color: "turquoise",
      details: [
        "Counselling techniques",
        "Mental health support",
        "Communication and listening skills",
        "Crisis intervention",
        "Ethical practice standards",
      ],
    },
    {
      id: 6,
      title: "HIV Management",
      description:
        "Specialized training in HIV care, management, support services, stigma reduction, and community education approaches.",
      duration: "Comprehensive online training",
      discount: "30% OFF",
      color: "pink",
      details: [
        "HIV care and treatment",
        "Support services management",
        "Stigma reduction strategies",
        "Community education",
        "Counseling for affected individuals",
      ],
    },
    {
      id: 7,
      title: "Event Planning",
      description:
        "Comprehensive training in event planning and management for both corporate and non-corporate events, from conception to execution.",
      duration: "Flexible scheduling available",
      discount: "30% OFF",
      color: "green",
      details: [
        "Event conceptualization",
        "Budget management",
        "Vendor coordination",
        "Logistics planning",
        "Marketing and promotion",
      ],
    },
    {
      id: 8,
      title: "Corporate Event Management",
      description:
        "Specialized training focused on corporate events including conferences, seminars, product launches, and team-building activities.",
      duration: "Flexible scheduling available",
      discount: "30% OFF",
      color: "blue",
      details: [
        "Corporate conference planning",
        "Seminar and workshop organization",
        "Product launch events",
        "Team-building activities",
        "Corporate hospitality",
      ],
    },
    {
      id: 9,
      title: "Beauty, Nails & Lashes",
      description:
        "Professional beauty training covering nail technology, eyelash application, and essential beauty treatments with a strong focus on hygiene, client care, and practical skills.",
      duration: "1 month theory + 2 months practical",
      discount: "30% OFF",
      color: "pink",
      details: [
        "Nail care and nail technology",
        "Acrylic and gel nail application",
        "Eyelash extensions and lash lifting",
        "Hygiene, sanitation, and safety practices",
        "Client consultation and aftercare",
      ],
    },
  ];

  const trainingOptions = [
    {
      title: "Online Training",
      description:
        "Flexible online learning with comprehensive manual books and digital resources accessible from anywhere.",
      icon: <OnlineTrainingIcon />,
    },
    {
      title: "Physical Practicals",
      description:
        "Hands-on practical training conducted in person to ensure real-world skill application and competency.",
      icon: <PhysicalTrainingIcon />,
    },
    {
      title: "Hybrid Learning",
      description:
        "Combination of online theoretical training and in-person practical sessions for comprehensive learning.",
      icon: <HybridTrainingIcon />,
    },
  ];

  return (
    <div className="services-page">
      {/* Hero Section */}
      <section className="services-hero section">
        <div className="container">
          <h1 className="section-title">Our Services & Training Programs</h1>
          <p className="section-subtitle">
            Passion Care 4 U offers comprehensive training programs designed to
            equip you with practical skills for personal and professional
            growth.
          </p>
        </div>
      </section>

      {/* Training Options */}
      <section className="training-options-section section">
        <div className="container">
          <h2 className="section-title">Training Formats</h2>
          <div className="training-options-grid">
            {trainingOptions.map((option, index) => (
              <div className="training-option-card" key={index}>
                <div className="option-icon">{option.icon}</div>
                <h3>{option.title}</h3>
                <p>{option.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* All Courses Section */}
      <section className="all-courses-section section">
        <div className="container">
          <h2 className="section-title">Comprehensive Course Catalog</h2>
          <p className="section-subtitle">
            All courses include detailed manual books and come with a{" "}
            <span className="highlight">30% discount</span>. Practical
            components are compulsory for skill certification.
          </p>

          <div className="all-courses-grid">
            {allCourses.map((course) => (
              <div className="detailed-course-card" key={course.id}>
                <div className="detailed-card-header">
                  <h3>{course.title}</h3>
                  {/* <div className="course-discount">{course.discount}</div> */}
                </div>
                <div className="detailed-card-body">
                  <p className="course-description">{course.description}</p>
                  <div className="course-duration">
                    <span className="duration-label">Duration:</span>
                    <span className="duration-value">{course.duration}</span>
                  </div>
                  <div className="course-details">
                    <h4>Course Coverage:</h4>
                    <ul>
                      {course.details.map((detail, idx) => (
                        <li key={idx}>{detail}</li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div className="detailed-card-footer">
                  <Link
                    to={`/enroll?course=${encodeURIComponent(course.title)}`}
                    className="btn-enroll"
                  >
                    Enroll Now
                  </Link>
                  <a href="/contact" className="btn-inquire">
                    Request Info
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Additional Services */}
      <section className="additional-services-section section">
        <div className="container">
          <h2 className="section-title">Additional Services</h2>
          <div className="services-list">
            <div className="service-item">
              <h3>Consultancy Services</h3>
              <p>
                Professional consulting in caregiving, child care, farming
                operations, warehouse management, and event planning for
                organizations and individuals.
              </p>
            </div>
            <div className="service-item">
              <h3>Job Placement Assistance</h3>
              <p>
                We assist graduates with job placements through both
                self-sponsorship and free sponsorship models, connecting trained
                professionals with employment opportunities.
              </p>
            </div>
            <div className="service-item">
              <h3>Community Programs</h3>
              <p>
                We organize and participate in community voluntary work,
                providing practical experience for our trainees while
                contributing to community development.
              </p>
            </div>
            <div className="service-item">
              <h3>Foundation & Charity Support</h3>
              <p>
                Training and support for establishing and managing charitable
                foundations and community organizations focused on care and
                development.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Global Training Info */}
      <section className="global-training-section section">
        <div className="container">
          <h2 className="section-title"> Training Accessibility</h2>
          <div className="global-training-content">
            <div className="global-info">
              <h3>
                Worldwide Training Through Global Training Online & Physical
                Training At Passion Care For You Offices.
              </h3>
              <p>
                Passion Care 4 U offers global training accessibility through
                Global Training Online and Physical Training At Passion Care For
                You Offices. If you want to do training in any country
                (including Morocco, UAE, USA, UK, etc.), all you need is to go
                to our local office or any other of the Passion Care Office
                Parks, show your documents, and book a training session.
              </p>
              <div className="location-list">
                {/* <div className="location-item">
                  <strong>Physical Training Centers:</strong> Johannesburg,
                  Zambia
                </div>
                <div className="location-item">
                  <strong>Online Training:</strong> Kenya, Mozambique
                </div> */}
                <div className="location-item">
                  <strong>Global Access:</strong> Anywhere via Global Training
                  Online & Physical Training At Passion Care For You Offices.
                </div>
              </div>
            </div>
            <div className="global-cta">
              <h4>Start Your Training Journey Today</h4>
              <p>
                Contact us to learn more about our training programs and how you
                can access them from anywhere in the world.
              </p>
              <a href="/contact" className="btn btn-secondary">
                Contact for Global Training
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
